<template>
<div class="pp-content">
    <div @click="$root.mobileBack()" v-if="$root.view == 'mobile'" class="pp-mobile-back pp-mobile-back--light">
        <i class="fa fa-fw fa-angle-left"></i>
    </div>
    <div v-if="empty" class="pp-header pp-header--simple pp-header--mobile-small">
        <div class="pp-header__title">
            Nothing queued
        </div>
        <div class="pp-header__content">
            Why not try browsing <router-link to="/browse/composers">popular composers</router-link>?
        </div>
    </div>
    <div v-if="!empty" class="pp-header pp-header--simple pp-header--mobile-small">
        <div class="pp-header__title">
            Now Playing
        </div>
        <div class="pp-header__content">
            Tracks in your queue and play history
        </div>
    </div>
    <div v-if="history.length > 0" class="pp-section">
        <div class="pp-section__header">
            History
        </div>
         <track-list :allow-remove="true" :reversed="true" :items="history" context-mode="from-history"></track-list>
    </div>
    <div v-if="current.length > 0" class="pp-section">
        <div class="pp-section__header">
            Now Playing
        </div>
        <track-list :allow-remove="true" :items="current"></track-list>
    </div>
    <div v-if="queue.length > 0" class="pp-section">
        <div class="pp-section__header">
            Up Next
        </div>
        <track-list :allow-remove="true" :items="queue" context-mode="from-queue"></track-list>
    </div>
</div>
</template>



<script>
import TrackList from '../components/TrackList.vue';
import EventBus from '../EventBus.js';
import TrackQueue from '../TrackQueue.js';

export default {
    name: 'queue',
    components: {
        TrackList
    },
    data() {
        return {
            queue: [],
            history: [],
            current: []
        };
    },
    computed: {
        empty() {
            return this.queue.length == 0 && this.history.length == 0 && (!this.current || this.current.length == 0);
        }
    },
    mounted() {
        TrackQueue.on('changed', (e) => {
            this.reload();
        });

        this.reload();
    },
    methods: {
        reload() {
            this.queue = TrackQueue.items;
            this.history = TrackQueue.history;
            this.current = TrackQueue.current ? [TrackQueue.current] : [];
        }
    }
}
</script>



// WEBPACK FOOTER //
// Queue.vue?5fa848ba